<template>
	<el-container class="home-container">
		<el-header>
			<h2>
				<img v-bind:src="logo" alt />
				<span>GMQM私有云</span>
			</h2>
			<el-dropdown trigger="click" @command="batchOperate">
				<span class="el-dropdown-link">
					欢迎，{{ nickname() }}
					<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item icon="el-icon-user" command="infromation">个人信息</el-dropdown-item>
					<el-dropdown-item icon="el-icon-switch-button" command="logout">退出</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</el-header>
		<el-container>
			<el-aside width="auto">
				<el-scrollbar style="height:100%">
					<Menu v-on:changeCollapse="changeCollapse" />
				</el-scrollbar>
			</el-aside>

			<transition name="fade" mode="out-in" appear>
				<el-main v-bind:style="{ height: screenHeight - 60 + 'px' }">
					<el-scrollbar style="height:100%">
						<router-view class="page-body" />
					</el-scrollbar>
				</el-main>
			</transition>
		</el-container>
	</el-container>
</template>

<script>
	import Menu from '../Menu.vue'
	import { mapActions, mapGetters, mapState } from 'vuex'
	export default {
		name: 'home',
		data() {
			return {
				msg: window.localStorage.getItem('name'),
				logo: require('@/assets/images/lusterinc-logo.png'),
				screenWidth: 0,
				screenHeight: 0,
			}
		},
		components: {
			Menu,
		},
		methods: {
			...mapActions(['Logout']),
			...mapGetters(['nickname', 'avatar', 'userInfo']),
			batchOperate(command) {
				switch (command) {
					case 'infromation':
						alert('gernxinxi')
						break
					case 'logout':
						this.logout()
						break
				}
			},
			/**
			 *
			 */
			changeCollapse(isCollapse) {
				console.log('changeCollapse', isCollapse)
				var elMain = document.getElementsByClassName('el-main')[0]
				if (elMain) {
					if (isCollapse) {
						elMain.classList.remove('collapse_open')
						elMain.classList.add('collapse_close')
					} else {
						elMain.classList.remove('collapse_close')
						elMain.classList.add('collapse_open')
					}
				}
			},
			logout() {
				const that = this
				this.$confirm('真的要注销登录吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						that
							.Logout({})
							.then(() => {
								window.location.href = '/'
								//window.location.reload()
							})
							.catch(err => {
								that.$message.error({
									title: '错误',
									description: err.message,
								})
							})
					})
					.catch(err => {
						that.$message.error(err.message)
					})
			},
		},
		mounted() {
			this.screenWidth = document.body.clientWidth
			this.screenHeight = document.body.clientHeight
			window.onresize = () => {
				return (() => {
					this.screenWidth = document.body.clientWidth
					this.screenHeight = document.body.clientHeight
				})()
			}
		},
	}
</script>
<style lang="less" scoped>
	.el-header {
		background-color: #000;
		color: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		> h2 {
			font-weight: 300;
			font-size: 18px;
			color: #ccc;

			> img {
				height: 18px;
			}

			> span {
				margin: -2px 5px 0 10px;
				display: inline-block;
				position: absolute;
				border-left: 1px #505050 solid;
				padding-left: 10px;
			}
		}

		.el-dropdown {
			color: #fff;
		}
	}
	.el-aside {
		background-color: #fff;
		border-right: 1px #ddd solid;
		.el-menu {
			border-right: none;
		}
	}
	.el-main {
		position: absolute;
		left: 251px;
		right: 0;
		bottom: 0;
		top: 60px;
		overflow-y: auto;
		overflow-x: hidden;
		padding: 0;
		transition: left 0.5s;
	}

	.collapse_close {
		left: 65px;
	}

	.collapse_open {
		left: 250px;
	}

	.home-container {
		height: 100%;
		overflow: hidden;
	}

	.page-body {
		padding: 20px;
	}
</style>
